import { useEffect } from 'react';

export const ChatWidget = () => {
  useEffect(() => {
    // Prevent duplicate loading
    if (document.getElementById('chatbot') || document.querySelector('.chatclient-button')) return;

    // Add position fix styles first
    if (!document.getElementById('chatbot-position-fix')) {
      const style = document.createElement('style');
      style.id = 'chatbot-position-fix';
      style.textContent = `
        .chatclient-button,
        .chatclient-button.active,
        img.chatclient-button {
          bottom: 70px !important;
          right: 16px !important;
          z-index: 9990 !important;
        }
      `;
      document.head.appendChild(style);
    }

    // Wrap script loading in try-catch and add error event listener
    try {
      const script = document.createElement('script');
      script.src = 'https://res.public.onecdn.static.microsoft/customerconnect/v1/7dttl/init.js';
      script.id = 'chatbot';
      script.setAttribute('environmentId', '3643e7f8-ed8b-e010-af44-6a3347bd9955');
      script.setAttribute('region', 'europe');
      script.crossOrigin = 'anonymous';
      script.async = true;
      
      // Suppress errors from the external script
      script.onerror = (e) => {
        console.warn('Microsoft Customer Connect script failed to load:', e);
      };
      
      document.body.appendChild(script);
    } catch (error) {
      console.warn('Error initializing chat widget:', error);
    }
  }, []);

  return null;
};
